export default __webpack_public_path__ + "static/media/Fiction.043ea7af.png";